import { TableWrapper, ViewTransactionButton } from '@basqet-dashboard/common/components';
import React, { useEffect } from 'react';

import { IS_ADMIN, PERMISSIONS } from '../../config';
import { useFetchTransactions } from '../../hooks/queries';
import { useHasPermission, useOpenTransactionDetails } from '../../hooks';
function Transactions() {
  useEffect(() => {
    setStatus('SUCCESSFUL');
  }, []);
  const {
    searchQuery,
    setSearchQuery,
    transactions,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    setStatus,
    isLoading,
    status,
    filterByDate
  } = useFetchTransactions();
  let showIsFetching =
    (!transactions.length && isLoading) || ((searchQuery || status) && isRefetching) || false;

  const hasPermission = useHasPermission();
  const canExportTransactions = hasPermission(PERMISSIONS.TRANSACTIONS_EXPORT);
  const openTransactionDetails = useOpenTransactionDetails();

  return (
    <div className="transactions">
      <TableWrapper
        data={transactions}
        name="transactions"
        headerName={IS_ADMIN ? 'admin_transactions' : 'transactions'}
        exportData={canExportTransactions}
        onLoadMore={fetchNextPage}
        canLoadMore={hasNextPage}
        hasFilters
        isFetching={showIsFetching}
        isLoading={isFetchingNextPage}
        onSearch={setSearchQuery}
        onStatusChange={setStatus}
        onDateFilter={filterByDate}
        rowAction={
          openTransactionDetails
            ? (transaction) => (
                <ViewTransactionButton transaction={transaction} onView={openTransactionDetails} />
              )
            : undefined
        }
      />
    </div>
  );
}

export { Transactions };
